if (document.querySelector('.inquiry-form')) {
    const metaTag = document.querySelector('meta[name="policy-link"]');

    const policyLink = metaTag.getAttribute('content');
    const policyLinks = document.querySelectorAll('a.inquiry-form__inject-policy-link');
    
    policyLinks.forEach(link => {
        link.setAttribute('href', policyLink);
    });
}

// Replace select first dummy option
document.addEventListener('DOMContentLoaded', function() {
    var lang = document.documentElement.lang;
    
    var select = document.querySelector('.wpcf7-form-control.wpcf7-select');

    if (select) {
        var firstOption = select.options[0];

        if (lang.startsWith('pl')) {
            firstOption.textContent = 'Wybierz z listy';
        } else if (lang.startsWith('en')) {
            firstOption.textContent = 'Please select an option';
        }
    }
});